export const getClassName = (className, css) => {
    let classes = className;

    let classNames = className.split(" ");
    if (classNames.length) {
        classNames.map((cn) => {
            if (["secWhite", "disabled", "link", "sidePadding", "borderBottom"].includes(cn)) {
                classes = classes ? classes.replaceAll(`${cn}`, "") : "";
                classes = classes ? classes + " " + css[cn] : classes + css[cn];
            }
            return true;
        });
    }

    return classes;
};
